import Marquee from "react-fast-marquee";
import { useNavigate } from "react-router-dom";
import { LogoMark } from "@/components/brand/Logo";

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#020617] pt-20" data-testid="footer">
      <div className="border-y border-white/5 py-8 overflow-hidden">
        <Marquee speed={60} autoFill>
          <span className="font-display text-[16vw] leading-none font-semibold text-outline mx-8 select-none">
            NOIZBLOC
          </span>
        </Marquee>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <LogoMark className="text-white" />
              <span className="font-display text-xl font-semibold text-white">Noizbloc</span>
            </div>
            <p className="mt-3 text-slate-500 max-w-xs text-sm leading-relaxed">
              Get your song heard. Music distribution for artists and labels.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-10 gap-y-3 text-sm">
            <button onClick={() => document.querySelector("#features")?.scrollIntoView({ behavior: "smooth" })} className="text-slate-400 hover:text-white transition-colors">Features</button>
            <button onClick={() => document.querySelector("#pricing")?.scrollIntoView({ behavior: "smooth" })} className="text-slate-400 hover:text-white transition-colors">Pricing</button>
            <button data-testid="footer-trending" onClick={() => navigate("/trending")} className="text-slate-400 hover:text-white transition-colors">Now Playing</button>
            <button onClick={() => document.querySelector("#faq")?.scrollIntoView({ behavior: "smooth" })} className="text-slate-400 hover:text-white transition-colors">FAQ</button>
            <button data-testid="footer-login" onClick={() => navigate("/login")} className="text-slate-400 hover:text-white transition-colors">Sign in</button>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-600">
          <span>© {year} Noizbloc. All rights reserved.</span>
          <span>Built for the underground.</span>
        </div>
      </div>
    </footer>
  );
}
